import { cssToken } from '@youhelp-ru/ui';

export const name = 'Avatar';
export const AvatarTokens = {
  Size: cssToken(name, 'size'),
};
